import React from 'react'
import { Text } from "@fluentui/react";
//import "office-ui-fabric-react/dist/css/fabric.css";

function StadisticCard(props) {

    //Parametros de entrada.
    const inputParam_Item = props.item !== null && props.item !== undefined ? props.item : null;
    const inputParam_ArrayLength = props.arrayLength !== null && props.arrayLength !== undefined ? props.arrayLength : 0;
    const inputParam_Index = props.index !== null && props.index !== undefined ? props.index : 0;

    const styles = {
        header: {
            root: {
                fontSize: 12,
                fontWeight: "bold",
                padding: "10px"
            }
        },
        amount: {
            root: {
                fontSize: "15px",
                verticalAlign: "middle",
            }
        }
    };
    return (
            <div index={inputParam_Index} title={inputParam_Item.name} length={inputParam_ArrayLength} style={{minWidth: "150px", backgroundColor: "#dadada", marginRight: "2px", borderLeft: "5px solid " + inputParam_Item.color, borderRight: inputParam_ArrayLength > inputParam_Index ? "1px solid #b7b7b7" : ""}}>
                <div style={{display: inputParam_Item.display ? "block" : "none"}} className="mx-2">
                    <div className="text-center">
                        <Text styles={styles.amount}>{`${inputParam_Item.code}`}</Text>
                    </div>
                    <div style={{fontSize: "small", whiteSpace : "nowrap"}} className="text-center">
                        {inputParam_Item.amount}
                    </div>
                </div>
            </div>
    );
}

export default StadisticCard;

